<mat-dialog-content>
  <div class="d-flex flex-row align-items-center justify-content-start">
    <img
      class="logo align-self-start"
      src="../../../../../assets/icons/icono.png"
      onerror="this.src = 'assets/img/cantfindimage.jpg'"
    />
    <div>
      <h2 mat-dialog-tittle>{{ 'Inventory Reclassifications' | translate }}</h2>
    </div>
  </div>

  <div class="selected-data">
    <span class="caption">{{ 'Reclassification' | translate }}</span>
  </div>

  <div class="custom-container">
    <form
      [formGroup]="reclassificationForm"
      class="d-flex flex-row justify-content-between align-items-center flex-column flex-lg-row"
    >
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Exit Article' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoExitArticle"
            formControlName="exitArticle"
          />
          <mat-autocomplete
            #autoExitArticle="matAutocomplete"
            [displayWith]="displayFnArticle"
          >
            @for (article of articleList; track article) {
              <mat-option class="multiline-mat-option" [value]="article">
                <strong>{{ article.codigo }}</strong> -
                {{ article.descripcion }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (
          reclassificationForm.get('exitArticle')?.value?.id_articulo;
          as articleId
        ) {
          <v-one-inventory-article-warning
            [articleId]="articleId"
            [articleCode]="
              reclassificationForm.get('exitArticle')?.value?.codigo ?? ''
            "
          />
        }
      </div>
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Exit Warehouse' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoExitWarehouse"
            formControlName="exitWarehouse"
          />
          <mat-autocomplete
            #autoExitWarehouse="matAutocomplete"
            [displayWith]="displayFnWarehouse"
          >
            @for (warehouse of warehouseExitFilter | async; track warehouse) {
              <mat-option class="multiline-mat-option" [value]="warehouse">
                {{ warehouse.nombre }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="custom-items-container">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Quantity' | translate }}</mat-label>
          <input
            type="number"
            matInput
            formControlName="value"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Entry Article' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoEntryArticle"
            formControlName="entryArticle"
          />
          <mat-autocomplete
            #autoEntryArticle="matAutocomplete"
            [displayWith]="displayFnArticle"
          >
            @for (article of articleList; track article) {
              <mat-option class="multiline-mat-option" [value]="article">
                <strong>{{ article.codigo }}</strong> -
                {{ article.descripcion }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (
          reclassificationForm.get('entryArticle')?.value?.id_articulo;
          as articleId
        ) {
          <v-one-inventory-article-warning
            [articleId]="articleId"
            [articleCode]="
              reclassificationForm.get('entryArticle')?.value?.codigo ?? ''
            "
          />
        }
      </div>
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Entry Warehouse' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoEntryWarehouse"
            formControlName="entryWarehouse"
          />
          <mat-autocomplete
            #autoEntryWarehouse="matAutocomplete"
            [displayWith]="displayFnWarehouse"
          >
            @for (warehouse of warehouseEntryFilter | async; track warehouse) {
              <mat-option class="multiline-mat-option" [value]="warehouse">
                {{ warehouse.nombre }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="selected-data">
    <span class="caption">{{ 'Date' | translate }}</span>
  </div>
  <div
    class="inputs-container d-flex flex-row justify-content-evenly align-items-center flex-column flex-lg-row"
  >
    <div class="date-container">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Date' | translate }}</mat-label>
        <input
          class="date-input"
          matInput
          [matDatepicker]="picker"
          [formControl]="dateForm"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="custom-items-container transfer-button">
      <button
        class="register-custom-button"
        mat-raised-button
        (click)="register()"
      >
        {{ 'Register' | translate }}
      </button>
    </div>
    <div class="custom-items-container transfer-button">
      <button mat-raised-button mat-dialog-close>
        {{ 'Close' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
